import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { env } from '../../environments/environment';
import { FlagGroup, ListResults, FlagGroupTag, FlagTemplate } from '../shared/interfaces';

@Injectable({
  providedIn: 'root',
})
export class FlagGroupService {
  constructor(protected http: HttpClient) {}

  listByInspection(id: number) {
    return this.http.get<ListResults<FlagGroup>>(`${env.APIUrl}/inspection/${id}/flaggroups`).toPromise();
  }

  get(id: number) {
    return this.http.get<FlagGroup>(`${env.APIUrl}/flaggroup/${id}`).toPromise();
  }

  edit(id: number, group: FlagGroup) {
    return this.http.put<FlagGroup>(`${env.APIUrl}/flaggroup/${id}`, group).toPromise();
  }

  updateOrder(inspectionId: number, groupIds: number[]) {
    return this.http.put<FlagGroup>(`${env.APIUrl}/inspection/${inspectionId}/updateGroupOrder`, groupIds).toPromise();
  }

  create(inspectionId: number, group: FlagGroup, applyTemplate: boolean = false) {
    return this.http.post<FlagGroup>(`${env.APIUrl}/flaggroup`, { inspectionId, group, applyTemplate }).toPromise();
  }

  createWithFlags(group: any, inspectionId: number, Flags) {
    return this.http
      .post<FlagGroup>(`${env.APIUrl}/flaggroup/create-withFlags`, { group, inspectionId, Flags })
      .toPromise();
  }

  remove(id: number) {
    return this.http.delete<FlagGroup>(`${env.APIUrl}/flaggroup/${id}`).toPromise();
  }

  addNote(groupId: number, note: { text: string }) {
    return this.http.put<FlagGroup>(`${env.APIUrl}/flaggroup/${groupId}/addnote`, note).toPromise();
  }

  removeNote(groupId: number, index: number) {
    return this.http.put<FlagGroup>(`${env.APIUrl}/flaggroup/${groupId}/removenote/${index}`, null).toPromise();
  }

  tags() {
    return this.http.get<FlagGroupTag[]>(`${env.APIUrl}/flagGroupTag`).toPromise();
  }

  templates(subGroupId: number) {
    return this.http.get<FlagTemplate[]>(`${env.APIUrl}/flagtemplate/subgroup/${subGroupId}`).toPromise();
  }

  getGroupName(groups, name) {
    const existingNames = groups.map(flag => flag.name);
    const baseNameExists = existingNames.includes(name);
    const existingNumbers = existingNames
      .map(n => {
        const match = n.match(new RegExp(`^${name} \\((\\d+)\\)$`));
        return match ? parseInt(match[1], 10) : null;
      })
      .filter(Number.isInteger)
      .sort((a, b) => a - b);
    let nextNumber = 1;
    const numberSet = new Set(existingNumbers);
    while (numberSet.has(nextNumber)) {
      nextNumber++;
    }

    return baseNameExists ? `${name} (${nextNumber})` : name;
  }
}
